<template>
  <div class="headbar_bg">
    <div class="headbar_left" :class="$store.state.app.collapse?'position-collapse-left':'position-left'">
      <!-- logo -->
      <router-link to="/">
        <div style="float: left;position: relative;margin-top: 5px;margin-left: 0px;">
          <img src="/static/img/home/top_title.png" border="0" alt="logo"/>
        </div>
      </router-link>

      <!--导航收缩-->
      <div class="hamburg" v-if="false">
        <el-menu class="el-menu-demo" text-color="#fff" :active-text-color="theme.themeColor" mode="horizontal">
          <el-menu-item index="1" @click="onCollapse">
            <hamburger :isActive="collapse"></hamburger>
          </el-menu-item>
        </el-menu>
      </div>
    </div>

    <div class="headbar_middle" style="display: flex">

    </div>

    <div class="headbar_right">
      <!-- 工具栏 -->
      <div class="toolbar">
        <div class="toolbar-content">
          <el-menu class="el-menu-demo" :text-color="theme.themeColor" :active-text-color="theme.themeColor"
                   mode="horizontal">

            <!--        <el-menu-item index="2" v-popover:popover-theme>-->
            <!--          &lt;!&ndash; 主题切换 &ndash;&gt;-->
            <!--          <li style="color:#fff;" class="fa fa-cube fa-lg"></li>-->
            <!--          <el-popover ref="popover-theme" placement="bottom-start" trigger="click" v-model="themeVisible">-->
            <!--            <div class="lang-item" @click="changeTheme('light')">浅色主题<span v-if="'light'==theme.themePath" class="fa fa-check"></span></div>-->
            <!--            <div class="lang-item" @click="changeTheme('dark')">深色主题<span v-if="'dark'==theme.themePath" class="fa fa-check"></span></div>-->
            <!--          </el-popover>-->
            <!--        </el-menu-item>-->

            <el-menu-item index="1" style="width:50px !important;">
              <!-- 操作手册按钮 -->
<!--              <li style="color:#fff;font-size: 22px;margin-right: 10px;" class="fa el-icon-question" title="操作手册下载" @click="downloadManual"></li>-->
            </el-menu-item>

<!--              <el-menu-item index="2" v-popover:popover-message>-->
<!--              &lt;!&ndash; 我的消息 &ndash;&gt;-->
<!--              <el-badge :value="taskData.length" :max="99" class="badge" type="danger" v-if="taskData.length>0">-->
<!--                <li style="color:#fff;" class="fa fa-envelope-o fa-lg"></li>-->
<!--              </el-badge>-->
<!--              <li style="color:#fff;" class="fa fa-envelope-o fa-lg" v-if="taskData.length === 0"></li>-->
<!--              <el-popover ref="popover-message" placement="bottom-end" trigger="click">-->
<!--                <message-panel></message-panel>-->
<!--              </el-popover>-->
<!--            </el-menu-item>-->

            <el-menu-item index="3" v-popover:popover-personal style="padding:0;margin-left: 20px;">
              <!-- 用户信息 -->
              <!--          <li style="color:#fff;" class="fa fa-user-o fa-lg"></li>-->
              <span class="user-info">欢迎您: &nbsp;{{user.displayName}}</span>&nbsp;
              <!--<span class="user-info"><img :src="user.portrait" />{{user.loginName}}</span>-->
              <img :src="require('@/assets/head.png')" width="37" height="37"
                   style="border-radius: 90px;"/>
              <el-popover ref="popover-personal" placement="bottom-end" trigger="click" :visible-arrow="false">
                <personal-panel :user="user"></personal-panel>
              </el-popover>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Hamburger from "@/components/Hamburger"
  import Action from "@/components/Toolbar/Action"
  import NoticePanel from "@/views/Core/NoticePanel"
  import MessagePanel from "@/views/Core/MessagePanel"
  import PersonalPanel from "@/views/Core/PersonalPanel"
  import {changeThemeData, initThemeData} from "@/utils/default"
  import "@/utils/base64.min"

  let myApp;
  export default {
    components: {
      Hamburger,
      Action,
      NoticePanel,
      MessagePanel,
      PersonalPanel
    },
    data() {
      return {
        taskData: [],
        user: {
          loginName: '',
          portrait: '',
        },
        activeIndex: '1',
        themeVisible: false,
        langVisible: false,
        personalVisible: false,
        isShowTopTool: false,
        theme: {},
        appName: '',
      }
    },
    methods: {
      // 加载用户信息
      findUserInfo: function () {
        this.$api.user.findUserInfo().then((res) => {
          // console.log("findUserInfo === "+JSON.stringify(res))
          sessionStorage.setItem('userId', res.data.userId);
          sessionStorage.setItem('displayName', res.data.displayName);
          let avatar = this.user.portrait
          this.user = res.data

          // 登录提醒密码修改
          if (this.user.passAlart != '') {
            this.$alert(this.user.passAlart, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }

          if (this.user.portrait != null && this.user.portrait != "") {

          } else {
            this.user.portrait = avatar
          }
        })
      },
      // 获取任务数据
      findTaskData: function () {
        this.$api.sysTaskDeal.unreadTasks().then((res) => {
          this.taskData = res.data.list
        })
      },
      openWindow(url) {
        window.open(url)
      },
      selectNavBar(key, keyPath) {
        // console.log(key, keyPath)
      },
      // 折叠导航栏
      onCollapse: function () {
        this.$store.commit('onCollapse')
      },
      // 主题切换
      changeTheme(themePath) {
        changeThemeData(this.$store.state.app, themePath);
        this.themeVisible = false;
        parent.window.location.reload();
      },

      // // 切换颜色
      // onThemeChange: function(themeColor) {
      //   this.$store.commit('setThemeColor', themeColor)
      // },
      // // 语言切换
      // ,changeLanguage(lang) {
      //   lang === '' ? 'zh_cn' : lang
      //   this.$i18n.locale = lang
      //   this.langVisible = false
      // },

    },
    mounted() {
      myApp = this;

      this.appName = globalConfig.appName;
      this.sysName = "";
      let user = sessionStorage.getItem("user");
      if (user) {
        this.user.loginName = user;
        this.user.portrait = require("@/assets/user.png")
      }
      this.findUserInfo();
      this.findTaskData();

      this.theme = initThemeData(this.$store.state.app);
      setTimeout(function (){
        myApp.$emit('passByValue', 'opma');
      },500)
    }
    , computed: {
      ...mapState({
        // themePath: state=>state.app.themePath,
        // themeColor: state=>state.app.themeColor,
        collapse: state => state.app.collapse
      })
    }
  }
</script>

<style scoped lang="scss">
  .headbar .el-menu.el-menu--horizontal {
    border-bottom: none !important;
  }

  .headbar_bg > > > .el-menu--horizontal > .el-menu-item {
    border-bottom: none;
    height: 100px;
    line-height: 100px;
  }

  .headbar_bg > > > .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: none;
  }

  .headbar_bg {
    background-image: url("/static/img/home/title_bg.png");
    background-position: right;
    background-size: 100%;
    height: 100px;
  }

  .headbar_left {
    width: 700px;
    height: 100px;
    line-height: 100px;
    /*position: fixed;*/
    top: 0;
    right: 0;
    z-index: 1030;
    float: left;

    .el-menu--horizontal {
      border-bottom: none !important;
    }
  }

  .headbar_right {
    width: auto;
    top: 0;
    right: 0;
    z-index: 1030;
    height: 60px;
    line-height: 60px;
    float: right;

    .el-menu--horizontal {
      border-bottom: none !important;
    }
  }

  .hamburg {
    float: left;
    position: relative;
    width: 50px;
    margin-left: 50px;
  }

  .navbar {
    float: left;
    margin-right: 10px;
    width: 240px !important;

    .el-menu-item {
      line-height: 64px;
    }
  }

  .toolbar {
    float: right;
    width: auto !important;
    text-align: right;
  }

  .toolbar-content {
    min-width: 280px;
    height: 80px;
    /*margin-left: 140px;*/
  }

  .toolbar-content .el-menu-item {
    /*margin-top: 7px !important;*/
  }

  .toolbar-content .el-menu-top {
    height: 75px !important;
  }

  .el-popover__reference {
    /*margin-left: 50px;*/
    /*padding-left: 25px;*/
  }

  .toolbar-content .el-menu-demo {
    height: 60px !important;
    /*border: 1px solid red;*/
  }

  .lang-item {
    font-size: 16px;
    padding-left: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
    cursor: pointer;

    span {
      color: green;
      margin-left: 15px;
    }
  }

  .lang-item:hover {
    font-size: 16px;
    background: #b0d6ce4d;
  }

  .user-info {
    min-width: 100px;
    font-family: Arial, serif;
    font-size: 13px;
    color: white;
    cursor: pointer;
  }

  .badge {
    line-height: 18px;
  }

  .position-left {
    left: 0;
  }

  .position-collapse-left {
    left: 0;
  }

  .el-menu-demo {
    /*width:200px !important;*/
    height: 75px !important;
    background: none !important;
    /*margin-top: 8px;*/
  }

  .hamburg .el-menu-demo {
    height: 100px !important;
  }

  .el-menu-item {
    /*background-color: rgba(0,0,0,0.5) !important;*/
    background: none !important;
  }

  .login_title {
    font-size: 26px;
    font-weight: bold;
    color: #ffffff;
    position: absolute;
    /*top: 7px;*/

    letter-spacing: 2px;
    margin-left: 10px;
  }

  //顶部菜单
  .headbar_middle {
    top: 0;
    left: 500px;
    position: absolute;
    /*border: 1px solid red;*/
  }
</style>



// WEBPACK FOOTER //
// src/views/Home/HeadBar.vue